import { Badge, type BadgeProps, Tooltip, useMantineColorScheme } from "@mantine/core"
import type { ComponentPropsWithoutRef, PropsWithChildren } from "react"

import { AppLink } from "../AppLink"
import classes from "./styles.module.css"

export type TTagBoxProps = PropsWithChildren<
  BadgeProps &
    Omit<ComponentPropsWithoutRef<"span">, keyof BadgeProps> & {
      tooltip?: string
      href?: string
      active?: boolean
    }
>

export function TagBox({ active, color, href, tooltip, ...props }: TTagBoxProps) {
  const { colorScheme } = useMantineColorScheme()
  color = color || (colorScheme === "dark" ? "gray" : "gray.7")
  active = active ?? !!href

  const core = (
    <Tooltip label={tooltip} disabled={!tooltip} withArrow>
      <Badge
        h={24}
        size="md"
        radius="sm"
        color={color}
        variant={active ? "outline" : "default"}
        classNames={classes}
        data-active={active ? true : undefined}
        {...props}
      />
    </Tooltip>
  )
  return href ? <AppLink href={href}>{core}</AppLink> : core
}
